
// import Vue from 'vue';
// import Vuex from 'vuex';

import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { isEmpty, isNil } from 'lodash';

export default {
  namespaced: true,
  state: {
    notifications: {
      count: 0,
      read: [],
      unread: [],
    },
  },
  mutations: {
    NOTIFICATIONS(state, newNotifications) {
      state.notifications = newNotifications;
    },
  },
  getters: {
    notifications: state => state.notifications,
    loaded: state => state.loaded,
  },
  actions: {
    initialiseStore(context, promise) {
      promise
        .then((response) => {
          context.commit('NOTIFICATIONS', isNil(response) ? [] : response.data.data);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/Notifications.js